import type { W_ReportType_FindReportTypeViewTable_VM } from 'ab-api/web/workOrderReport/reportTypeViewTable';

import { WorkOrderStatus } from '@acceligentllc/shared/enums/workOrderStatus';

const CSV_HEADER_KEYS = [
	'Report Type',
	'Field Report',
	'Company',
	'Start Date',
	'FR Status',
	'RT Status',
];

export const toCSVData = (viewModels: W_ReportType_FindReportTypeViewTable_VM['rows'][number][]): string[][] => {
	const header: string[] = [...CSV_HEADER_KEYS];

	const rows: string[][] = viewModels.map((_entry: W_ReportType_FindReportTypeViewTable_VM['rows'][number]) => {
		const _row: string[] = [
			_entry.reportTypeName,
			_entry.workOrderCode,
			_entry.companyName,
			_entry.startDate,
			_entry.workOrderStatus !== WorkOrderStatus.CANCELED
				? _entry.calculatedReportDisplayStatus
				: 'N/A',
			_entry.isContainingData ? 'Containing data' : 'Empty',
		];
		return _row;
	});

	return [header, ...rows];
};
